import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Actions */
import * as loginActions from '../../actions/login/index';

/*Style*/
import '../../../../public/style/dashboard.scss';

class AccountGeozoneCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('geozones');
    if (!permit) {
      this.props.history.push('/dashboard/authorization');
    }
  }

  render() {
    return (
      <section className="main">
        <div className="main-container">
          <h1>AccountGeozoneCategory</h1>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

AccountGeozoneCategory.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountGeozoneCategory);



// WEBPACK FOOTER //
// ./source/client/containers/account_geozone_category/index.jsx